import React from "react";
import NavBarView from "./view";
import { features } from "../../../static";
import { usePersistedState } from "../../../context/PersistedStateProvider";
import { useBuildPermittedNavigationLinks } from "../../../hooks/useBuildPermittedNavigationLinks";

export default function NavBar() {
  const { custom_projects: { defaultCustomProject } = {} } =
    usePersistedState();
  const projectId =
    defaultCustomProject?.value?.length > 0
      ? defaultCustomProject?.value[0]
      : null;
  const permittedNavigationLinks = useBuildPermittedNavigationLinks(
    features,
    projectId
  );

  return <NavBarView features={permittedNavigationLinks} />;
}
